import IconComingSoon from "../icon-coming-soon/icon-coming-soon";
import { IconProps, ICON_SIZE } from "../icon-props-interface";
import './icon.scss';

interface Props extends IconProps {
	Component: React.FC<IconProps>;
	disabled?: boolean;
	comingSoon?: boolean;
    size?: ICON_SIZE;
}

const COLOR_DISABLED = 'var(--color-primary-3-20)';

const Icon: React.FC<Props> = ({ Component, disabled, comingSoon, color, size = ICON_SIZE.SMALL }) => {
	const colorToSet = disabled ? COLOR_DISABLED : color;

    const sizeClass = size === ICON_SIZE.MEDIUM ? 'medium' : '';
    return (
		<div className={`icon ${sizeClass}`}>
			<Component color={colorToSet} size={size}></Component>
            { comingSoon && 
                <div className="coming-soon">
                    <IconComingSoon /> 
                </div>
            }
        </div>
    );
}

export default Icon;
